import { defineComponent as p, computed as n, createBlock as u, openBlock as r, unref as i, mergeProps as f } from "vue";
import b from "../SliderBase/SliderBase.vue2.js";
const y = /* @__PURE__ */ p({
  name: "RevRange",
  inheritAttrs: !1,
  __name: "Range",
  props: {
    disabled: { type: Boolean, default: !1 },
    keyboardStep: { default: 1 },
    label: {},
    max: {},
    min: { default: 0 },
    modelValue: {},
    showSteps: { type: Boolean, default: !1 },
    step: { default: 1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: o }) {
    const s = t, d = o, a = n({
      get() {
        return s.modelValue;
      },
      set(e) {
        d("update:modelValue", e);
      }
    });
    return (e, l) => (r(), u(i(b), f(e.$attrs, {
      modelValue: a.value,
      "onUpdate:modelValue": l[0] || (l[0] = (m) => a.value = m),
      disabled: e.disabled,
      "keyboard-step": e.keyboardStep,
      label: e.label,
      max: e.max,
      min: e.min,
      "show-steps": e.showSteps,
      step: e.step
    }), null, 16, ["modelValue", "disabled", "keyboard-step", "label", "max", "min", "show-steps", "step"]));
  }
});
export {
  y as default
};
